export default {
  providerName: 'productProvider',
  items: {
    mainProduct: {}
  }
};